import React from "react";
import {
  Formik,
  Form as FormikForm,
  Field,
  ErrorMessage,
  useFormikContext,
} from "formik";
import Datepicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export function Form(props) {
  return (
    <Formik {...props}>
      <FormikForm>{props.children}</FormikForm>
    </Formik>
  );
}

export function TextFields(props) {
  const { name, label, placeholder, ...rest } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <Field
        className="form-control"
        type="text"
        name={name}
        id={name}
        placeholder={placeholder || ""}
        {...rest}
      />
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

// SELECT BOX
export function SelectField(props) {
  const { name, label, options } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <Field as="select" id={name} name={name}>
        <option value="">Choose...</option>
        {options.map((optn, index) => (
          <option
            key={index}
            value={optn.value}
            label={optn?.label || optn.value}
          />
        ))}
      </Field>
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

// RADIO BOX
export function RadioField(props) {
  const { name, label, options = [] } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <br />
      {options.map((data) => (
        <div key={data.value}>
          <label htmlFor={data.value}>
            <Field
              type="radio"
              name={name}
              id={data.value}
              value={data.value}
            />
            {data?.label}
          </label>
          <br />
        </div>
      ))}
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

// CHECKBOX
export function CheckField(props) {
  const { name, label, options } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <br />
      {options.map((data) => (
        <div key={data.value}>
          <label htmlFor={data.value}>
            <Field
              type="checkbox"
              name={name}
              id={data.value}
              value={data.value}
            />
            {data?.label}
          </label>
          <br />
        </div>
      ))}
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

export function TextArea(props) {
  const { name, label, placeholder, ...rest } = props;
  return (
    <>
      {label && <label htmlFor={name}>{label}</label>}
      <Field
        className="form-control"
        type="textarea"
        name={name}
        id={name}
        placeholder={placeholder || ""}
        {...rest}
      />
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

export function DateField(props) {
  const { label, name, ...rest } = props;
  return (
    <>
      {<label htmlFor={name}>{label}</label>}
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          const { value } = field;
          return (
            <Datepicker
              id={name}
              {...field}
              {...rest}
              selected={value}
              onChange={(val) => setFieldValue(name, val)}
              showYearDropdown
              showMonthDropdown
              dropdownMode="select"
              dateFormat="MM/dd/yyyy"
            />
          );
        }}
      </Field>
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

export function TimeField(props) {
  const [startDate] = React.useState(new Date());
  const { label, name, ...rest } = props;
  return (
    <>
      {<label htmlFor={name}>{label}</label>}
      <Field name={name}>
        {({ form, field }) => {
          const { setFieldValue } = form;
          return (
            <Datepicker
              id={name}
              {...field}
              {...rest}
              selected={startDate}
              onChange={(val) => setFieldValue(name, val)}
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={15}
              timeCaption="Time"
              dateFormat="h:mm aa"
            />
          );
        }}
      </Field>
      <ErrorMessage
        name={name}
        render={(msg) => <div style={{ color: "red" }}>{msg}</div>}
      />
    </>
  );
}

export function SubmitButton(props) {
  const { label, ...rest } = props;
  const { isSubmitting } = useFormikContext();

  return (
    <button type="submit" {...rest} disabled={isSubmitting}>
      {label}
    </button>
  );
}
